

// ----------------------------------
// -------- RNBO INTEGRATION --------
// ----------------------------------


export function initRNBO() {

    if (document.getElementById('startButton')) {

        const { createDevice, TimeNow, MessageEvent } = RNBO; 

        let device;
        let context;
        let micdB = 0;
        let noteStatus = 0;
        let micGainParam;

        // Obtener datos del HTML
        const instrumentElement = document.getElementById('instrumentRNBO');
        const rnboJsonUrl = instrumentElement.dataset.rnboJson;
        const sampleHighUrl = instrumentElement.dataset.sampleHigh;
        const sampleLowUrl = instrumentElement.dataset.sampleLow || null;
        const sustainHighPoints = instrumentElement.dataset.sustainHigh.split(',').map(Number);
        const sustainLowPoints = sampleLowUrl ? instrumentElement.dataset.sustainLow.split(',').map(Number) : null;

        const SAMPLES = {
            "sampleSilbatoGrave": sampleLowUrl,
            "sampleSilbatoAgudo": sampleHighUrl,
        };

        const sustainLoopPoints = {
            "grave": sustainLowPoints,
            "agudo": sustainHighPoints,
        };

        // Referencias a elementos del DOM

        const startButton = document.getElementById('startButton');
        const closeButton = document.getElementById('closeButton');

        const lowButton = document.getElementById('lowButton');
        const highButton = document.getElementById('highButton');
        const micBigButton = document.getElementById('bigButton');
        const micGainSlider = document.getElementById('micGainSlider');
        const micViewGain = document.getElementById('micViewGain');

        // Clase para gestionar botones
        class Button {
            constructor(inportTag) {
                this.state = 0;
                this.lastState = 0;
                this.inportTag = inportTag;
            }

            press() {
                this.state = 1;
                this.update();
                if(this.inportTag=='lowHighNote') micBigButton.classList.add('active');
            }

            release() {
                this.state = 0;
                this.update();
                if(this.inportTag=='lowHighNote') micBigButton.classList.remove('active');
            }

            update() {
                if (this.state !== this.lastState) {
                    sendMessageToInport(this.state, this.inportTag);
                    this.lastState = this.state;
                    console.log(`[Button] ${this.inportTag} state updated: ${this.state}`);
                }
            }
        }

        const lowNoteButton  = new Button('notaAlta');
        const highNoteButton = new Button('notaBaja');
        const micNoteButton  = new Button('lowHighNote');


        const micViewAnim = document.getElementById('micView__anim');
        const micViewAnimBars = micViewAnim.querySelectorAll('.bar'); // Obtener todos los elementos con la clase "bar"

        // Actualizar nivel del micrófono
        function updateMicLevel() {
            if (micViewAnimBars) {

                //console.log("micdB",micdB)
                let calc = Math.min(100, Math.max(0, micdB + 80));
                //let calc = Math.min(100, Math.max(0, micdB + 60));
                //console.log("micdB>calc",calc)
                //let calc = Math.min(100, Math.max(0, micdB * 4 + 100));
                //micViewGain.style.width = `${calc}%`;
                //console.log(`[Mic Level] Updated to ${micViewGain.style.width}`);


                // Animacion

                micViewAnimBars.forEach((bar, index) => {
                    const rangeMin = index * 10; // Rango mínimo de la barra (0%, 10%, 20%, ...)
                    const rangeMax = (index + 1) * 10; // Rango máximo de la barra (10%, 20%, 30%, ...)
        
                    if (calc >= rangeMin) {
                        bar.classList.add('active'); // Agregar clase "active" si está dentro del rango
                        const opacity = 1; // Calcular opacidad (0.1 a 1)
                        bar.style.opacity = opacity.toFixed(2); // Aplicar opacidad
                    } else {
                        bar.classList.remove('active'); // Quitar clase "active" si no está dentro del rango
                        bar.style.opacity = '0.1'; // Establecer opacidad mínima
                    }
                });



            }
        }

        micGainSlider.addEventListener('input', () => {
            if (micGainParam) {
                micGainParam.value = parseFloat(micGainSlider.value);
                console.log(`[Mic Gain Slider] Value: ${micGainSlider.value}`);
            }
        });

        async function loadRNBOdevice() {
            if (device) return;

            console.log("[RNBO] Initializing device...");

            let WAContext = window.AudioContext || window.webkitAudioContext;
            context = new WAContext();
            const outputNode = context.createGain();
            outputNode.connect(context.destination);

            const rawPatcher = await fetch(rnboJsonUrl);
            const patcher = await rawPatcher.json();
            device = await createDevice({ context, patcher });

            await loadSamples(SAMPLES);

            //console.log("suscribing to events...")
            device.messageEvent.subscribe((event) => {

                //console.log("event",event.tag, event)

                if (event.tag === "out3") {
                    micdB = event.payload;
                    updateMicLevel();
                }
                
                if (event.tag === "out4") {
                    noteStatus = event.payload;
                    console.log('[RNBO Event] Note status updated:', noteStatus);
                }

            });

            connectMicrophone();

            //device.node.connect(outputNode);
            device.node.connect(context.destination);

            micGainParam = device.parametersById.get("micGain");
            micGainParam.value = 6;

            document.body.onclick = () => context.resume();

            console.log("[RNBO] Device loaded successfully.");
        }

        async function loadSamples(samples) {
            for (let id in samples) {
                if (samples[id]) {
                    await loadSample(samples[id], id);
                }
            }
            loadSustainLoopPoints();
            sendMessageToInport(0.5, "normalizeSampleBuffer");
        }

        async function loadSample(url, id) {
            try {
                const response = await fetch(url);
                const arrayBuffer = await response.arrayBuffer();
                const audioBuffer = await context.decodeAudioData(arrayBuffer);
                await device.setDataBuffer(id, audioBuffer);
                console.log(`[Sample] ${id} loaded successfully.`);
            } catch (error) {
                console.error(`[Sample] Failed to load ${id}:`, error);
            }
        }

        let micStream; // Mantendremos una referencia al stream del micrófono

        function connectMicrophone() {
            navigator.mediaDevices.getUserMedia({ audio:  { //para eliminar configuraciones indeseadas
                echoCancellation: false,
                noiseSuppression: false,
                autoGainControl: false
            }, video: false }).then((stream) => {
                micStream = stream;
                const source = context.createMediaStreamSource(stream);
                source.connect(device.node);
                console.log('[Mic] Microphone connected');
            }).catch((error) => {
                console.error('[Mic] Failed to connect microphone:', error);
            });
        }

        function disconnectMicrophone() {
            if (micStream) {
                micStream.getTracks().forEach(track => track.stop()); // Detener todas las pistas de audio
                micStream = null; // Limpiar la referencia al stream
                console.log('[Mic] Microphone disconnected');
            }
        }
                
        function loadSustainLoopPoints() {

            if (sustainLoopPoints.grave) {
                const lowStart = device.parametersById.get("initSustainGrave");
                lowStart.value = sustainLoopPoints.grave[0];

                const lowEnd = device.parametersById.get("endSustainGrave");
                lowEnd.value = sustainLoopPoints.grave[1];
            }

            const highStart = device.parametersById.get("initSustainAgudo");
            highStart.value = sustainLoopPoints.agudo[0];

            const highEnd = device.parametersById.get("endSustainAgudo");
            highEnd.value = sustainLoopPoints.agudo[1];

            console.log('[Sustain Points] Loaded successfully.');
        }

        function sendMessageToInport(message, inportTag) {
            const event = new MessageEvent(TimeNow, inportTag, [message]);
            try {
                device.scheduleEvent(event);
                console.log(`[Inport] Message sent to ${inportTag}: ${message}`);
            } catch (error) {
                console.error(`[Inport] Failed to send message to ${inportTag}:`, error);
            }
        }

        
        if (lowButton) {
            // Soporte para Desktop
            lowButton.addEventListener('mousedown', () => lowNoteButton.press());
            lowButton.addEventListener('mouseup', () => lowNoteButton.release());
            // Soporte para Mobile
            lowButton.addEventListener('touchstart', (e) => {
                e.preventDefault(); // Evitar que los eventos táctiles activen el click también
                lowNoteButton.press();
            });
            lowButton.addEventListener('touchend', (e) => {
                e.preventDefault();
                lowNoteButton.release();
            });
        }
        
        if (highButton) {
            // Soporte para Desktop
            highButton.addEventListener('mousedown', () => highNoteButton.press());
            highButton.addEventListener('mouseup', () => highNoteButton.release());
            // Soporte para Mobile
            highButton.addEventListener('touchstart', (e) => {
                e.preventDefault();
                highNoteButton.press();
            });
            highButton.addEventListener('touchend', (e) => {
                e.preventDefault();
                highNoteButton.release();
            });
        }
        
        if (micBigButton) {
            // Soporte para Desktop
            micBigButton.addEventListener('mousedown', () => micNoteButton.press());
            micBigButton.addEventListener('mouseup', () => micNoteButton.release());
            // Soporte para Mobile
            micBigButton.addEventListener('touchstart', (e) => {
                e.preventDefault();
                micNoteButton.press();
            });
            micBigButton.addEventListener('touchend', (e) => {
                e.preventDefault();
                micNoteButton.release();
            });
        }        

        // Open/Start and close

        startButton.addEventListener('click', () => {

            if(device) connectMicrophone()

            loadRNBOdevice();
            document.getElementById('micView').style.display = "block";
            console.log('[Mic Button] RNBO device loading initiated.');
        });

        closeButton.addEventListener('click', () => {
            disconnectMicrophone()
            document.getElementById('micView').style.display = "none";
        });

        // Verificar si existe el parámetro ?start=rnbo en la URL
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('start') === 'rnbo') {
            setTimeout(function(){
                startButton.click();
            },1000);
        }	
        



        // Toggle

        const toggleHeader = document.querySelector('.micView__fall__toggle');
        const options = document.querySelector('.micView__fall__options');
    
        // Inicialmente ocultamos las opciones
        options.style.display = 'none';
    
        // Agregar evento al encabezado para el toggle
        toggleHeader.addEventListener('click', () => {
            if (options.style.display === 'none') {
                options.style.display = 'block'; // Mostrar las opciones
            } else {
                options.style.display = 'none'; // Ocultar las opciones
            }
        });




    }






}


